import { apiClient } from "../config";

async function getCommunityMapGeographies(communityId: string) {
  const res = await apiClient.get(`/admin/communities/${communityId}/regions`);
  return res.data;
}

export default getCommunityMapGeographies;
